import React from "react";
import { Menu, Button } from "@chakra-ui/react";

export const STATUS_OPTIONS = [
  { value: "NEW", label: "New" },
  { value: "PENDING", label: "Pending" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "RESOLVED", label: "Resolved" },
];

export function StatusSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const selected = STATUS_OPTIONS.find((opt) => opt.value === value);
  return (
    <Menu.Root onSelect={(details) => onChange(details.value)}>
      <Menu.Trigger asChild>
        <Button variant='outline' width='100%' justifyContent='space-between'>
          {selected ? selected.label : "Select status"}
          <span>&#9660;</span>
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content width='200px'>
          <Menu.ItemGroup>
            {STATUS_OPTIONS.map((opt) => (
              <Menu.Item key={opt.value} value={opt.value}>
                {opt.label}
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}
